exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n    margin-left:-5px;\n    margin-right:-5px;\n  }\n    \n  .column {\n    float: left;\n    width: 50%;\n    padding: 5px;\n  }\n  \n  /* Clearfix (clear floats) */\n  .row::after {\n    content: \"\";\n    clear: both;\n    display: table;\n  }\n  \n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    border: 1px solid #ddd;\n  }\n  \n  th, td {\n    text-align: left;\n    padding: 16px;\n  }\n  \n  tr:nth-child(even) {\n    background-color: #f2f2f2;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/sorting-questions/sorting-questions.component.css
// module id = ../../../../../src/app/questions/sorting-questions/sorting-questions.component.css
// module chunks = main